export default {
  init() {

  },
  finalize() {
    var perPage = $('.load-more-btn').data('index');

    $('.load-more-btn').on('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const currentIndex = $(this).data('index');
      const newIndex = currentIndex + perPage

      for (let i = currentIndex; i < newIndex; i++) {
        $(`.resource-item[data-index="${i}"]`).removeClass('d-none');
      }
      
      $(this).data('index', newIndex);

      if ($(`.resource-item[data-index="${newIndex}"]`).length == 0) {
        $(this).parent().addClass('d-none');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/routes/templateResourceListing.js